


































import {
	defineComponent,
} from '@vue/composition-api';
import { Size, Spacing } from '@front-app/components/constants';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import TrForm from '@front-app/components/form/Form.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';

export default defineComponent({
	components: {
		TrForm,
		CtaButton,
		ErrorCard,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		testid: {
			type: String,
			required: true,
		},
		isSaving: Boolean,
		isErrorSaving: Boolean,
		disabled: Boolean,
	},
	setup() {
		return {
			// Util
			Size,
			Spacing,
			ButtonPalettes,
		};
	},
});
